if (typeof active_affiliate !== 'undefined') {
  const announcement_bar = document.querySelector("#announcement__slider")

  if (announcement_bar) {
    const slideContainer = document.createElement("div")
    slideContainer.className = "keen-slider__slide"

    const affiliate_msg = document.createElement("h6")
    affiliate_msg.className = "announcement-bar__message announcement-bar__message--affiliate mobile--smaller"

    const parts = active_affiliate.msg.split("_code_")

    const link = document.createElement("a")
    link.href = "/collections/" + active_affiliate.collection_handle 
    link.classList.add("announcement-bar__message--affiliate"); 
    link.appendChild(document.createTextNode(parts[0]))
    affiliate_msg.appendChild(link);

    const discountCode = document.createElement("span");
    discountCode.classList.add("textToCopy"); 
    discountCode.textContent = active_affiliate.discount_code // the actual code instead of _code_
    affiliate_msg.appendChild(discountCode);
    discountCode.addEventListener('click', function (e) {
      let textToCopy = e.target.innerText;
      copyToClipboard(textToCopy);
    });


    if (parts[1]) { 
      const link2 = document.createElement("a")
      link2.href = "/collections/" + active_affiliate.collection_handle 
      link2.classList.add("announcement-bar__message--affiliate"); 
      link2.appendChild(document.createTextNode(parts[1]))
      affiliate_msg.appendChild(link2);
    }
    
    slideContainer.appendChild(affiliate_msg)
    announcement_bar.insertBefore( slideContainer,  announcement_bar.children[1] || null );
    window?.announcementSlider.update();

    // set a new cookie expires after 7 days for the new message
    if (getCookie('affiliate_announcement') != slideContainer.outerHTML) {
      setCookie('affiliate_announcement',  slideContainer.outerHTML, 7)
    }

  }
}


if (window.location && window.location.href && window.location.href.includes('/collections/tall-collection')) {
  let tallPopupSignup = document.querySelector('.vertical-popup-signup--tall');
  
  // Check if popup already shown this session
  let alreadyShown = sessionStorage.getItem('tallPopupShown') === 'true';
  
  if (alreadyShown && tallPopupSignup) {
    // If already shown, make button visible immediately
    tallPopupSignup.classList.remove("hidden");
  } else {
    // auto-open tall popup after 10s on tall collection page (once per session)
    setTimeout(function() {
      openPopup('Rcq94G', 'tallPopupShown', true);
      if (tallPopupSignup) {
        tallPopupSignup.classList.remove("hidden")
      }
    }, 10000);
  }

  // floating corner button to open tall popup only on tall collection page
  if (tallPopupSignup) {
    tallPopupSignup.addEventListener('click', function(e) {
      e.preventDefault();
      openPopup('Rcq94G', 'tallPopupShown', false);
    });
  }
}else if (window.location && window.location.href && window.location.href.includes('/collections/') && window.location.href.includes('petite') ) {
  let petitePopupSignupDesktop = document.querySelector('.vertical-popup-signup--petite-desktop');
  let petitePopupSignupMobile = document.querySelector('.vertical-popup-signup--petite-mobile');
  
  // Check if popup already shown this session
  let alreadyShown = sessionStorage.getItem('petitePopupShown') === 'true';
  
  if (alreadyShown) {
    // If already shown, make buttons visible immediately
    if (petitePopupSignupMobile) {
      petitePopupSignupMobile.classList.remove("hidden");
    }
    if (petitePopupSignupDesktop) {
      petitePopupSignupDesktop.classList.remove("hidden");
    }
  } else {
    // auto-open petite popup after 10s on petite collection page (once per session)
    setTimeout(function() {
      // Check if screen width is less than small breakpoint (749px)
      if (window.innerWidth < 749) {
        openPopup('RGFxX9', 'petitePopupShown', true); // Mobile popup
      } else {
        openPopup('V34hTz', 'petitePopupShown', true); // Desktop popup
      }
      if (petitePopupSignupMobile) {
        petitePopupSignupMobile.classList.remove("hidden")
      }
      if (petitePopupSignupDesktop) {
        petitePopupSignupDesktop.classList.remove("hidden")
      }
    }, 10000);
  }

  // floating corner button to open petite popup
  if (petitePopupSignupDesktop) {
    petitePopupSignupDesktop.addEventListener('click', function(e) {
      e.preventDefault();
      openPopup('V34hTz', 'petitePopupShown', false);
    });
  }
  if (petitePopupSignupMobile) {
    petitePopupSignupMobile.addEventListener('click', function(e) {
      console.log('petitePopupSignupMobile clicked');
      e.preventDefault();
      openPopup('RGFxX9', 'petitePopupShown', false);
    });
  }
}

function openPopup(popupId = 'Rcq94G', sessionKey = null, checkSession = true) {
  // Check if popup has already been shown this session (only for auto-open)
  if (checkSession && sessionKey && sessionStorage.getItem(sessionKey) === 'true') {
    return;
  }
  
  // ensures Klaviyo is initialized and has time to reset between opens
  if (window._klOnsite && typeof window._klOnsite.push === 'function') {
    setTimeout(() => {
      window._klOnsite.push(['openForm', popupId]);
      // Mark as shown in session storage
      if (sessionKey) {
        sessionStorage.setItem(sessionKey, 'true');
      }
    }, 200);
  } else {
    console.warn('Klaviyo not ready yet — retrying...');
    setTimeout(() => openPopup(popupId, sessionKey, checkSession), 500);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (typeof window.scheduleCollectionAdLayout === "function") {
    window.scheduleCollectionAdLayout(500);
  } else {
    setTimeout(moveCollectionAdFixed, 500);
  }
});

// ==================== Gender Switch ====================
(function () {
  const btns = document.querySelectorAll('.gender-switch__btn');
  if (!btns.length) return;

  const slider = document.querySelector('.gender-switch__slider');

  btns.forEach(btn => {
    btn.addEventListener('click', function () {
      if (this.classList.contains('active')) return;

      const gender = this.dataset.gender;

      btns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');

      slider.classList.remove('active-men', 'active-women');
      slider.classList.add('active-' + gender);

      document.querySelectorAll('.product-card--men, .product-card--women').forEach(card => {
        card.classList.add('hidden');
      });
      document.querySelectorAll('.product-card--' + gender).forEach(card => {
        card.classList.remove('hidden');
      });
      window.refreshCollectionProductCountDisplay?.();
      window.refreshCollectionColorFacets?.();
    });
  });

  // URL param: ?load=women
  const params = new URLSearchParams(window.location.search);
  if (params.get('load')?.toLowerCase() === 'women') {
    const womenBtn = document.querySelector('.gender-switch__btn[data-gender="women"]');
    if (womenBtn) womenBtn.click();
  }
})();
// ==================== End Gender Switch ====================
class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.gridName = "#product-grid";
    this.gridContainer = document.querySelector("#product-grid");
    this.init();
    this.page = 1;
  }

  init() {
    // Calculate rootMargin: first product card height × 4 rows
    const firstCard = this.gridContainer?.querySelector('.product-card');
    const rootMargin = firstCard 
      ? `${Math.ceil(firstCard.getBoundingClientRect().height * 4)}px`
      : '1200px'; // Fallback
    
    const observer = new IntersectionObserver(this.revealItem.bind(this), {
      root: null,
      rootMargin: rootMargin,
      threshold: 0.05,
    });
    observer.observe(this);
  }

  fetchNextPage(e) {
    if (e <= this.dataset.pageSize) {
      const url = new URL(this.dataset.next, window.location.origin);
      url.searchParams.set("page", e);    
      const r = url.href;

      fetch(r, {
        method: "GET",
        headers: { "Content-Type": "text/html" },
      })
        .then((res) => res.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, "text/html");
          const nextGrid = doc.querySelector(this.gridName);
          const htmlToInsert = nextGrid?.innerHTML;
          if (!htmlToInsert) return;

          this.gridContainer.insertAdjacentHTML("beforeend", htmlToInsert);
          window.syncCollectionSizeFilteredCards?.();
          window.refreshCollectionProductCountDisplay?.();
          if (typeof window.sortProductCards === 'function') {
            window.sortProductCards();
          }
          if (typeof window.productCardColorSwatchesScroll === 'function') {
            window.productCardColorSwatchesScroll(this.gridContainer);
          }
          if (typeof initProductCardVideos === 'function') {
            initProductCardVideos(this.gridContainer);
          }
          if (typeof window.scheduleCollectionAdLayout === 'function') {
            window.scheduleCollectionAdLayout(50);
          } else if (typeof moveCollectionAdFixed === 'function') {
            setTimeout(moveCollectionAdFixed, 50);
          }

            const newNext = doc.querySelector("infinite-scroll")?.dataset?.next;
            if (newNext) {
              this.dataset.next = newNext;
            } else {
              this.dataset.pageSize = this.page; 
            }
            // Show end text when reaching the last page (on successful fetch)
            if (e == this.dataset.pageSize) {
              this.innerHTML = `<p>${this.dataset.endText}</p>`;
            }
        })
        .catch((err) => {
          console.error("Infinite scroll fetch error:", err);
        });
    }
  }

  revealItem(e, t) {
    const [i] = e;
    if (!i.isIntersecting || this.dataset.pageSize <= 1) return;
    if (i.target) {
      this.page++;
      this.fetchNextPage(this.page);
    }
    if (this.page == this.dataset.pageSize) {
      t.unobserve(i.target);
    }
  }
}
customElements.define("infinite-scroll", InfiniteScroll);


